import { NotificationData } from ".";

const notificationDatas: NotificationData[] = [
  {
    code: "KFV-000", // DO NOT USE!
    developerMessage: "Unknown validation.",
    type: "validation",
  },
  {
    autoClose: true,
    code: "KFV-001",
    developerMessage: "Draft saved.",
    type: "validation",
  },
  {
    autoClose: true,
    code: "KFV-002",
    developerMessage: "Photo(s) uploaded.",
    type: "validation",
  },
];

export default notificationDatas;
